module.exports = __webpack_public_path__ + "img/bg_service_active.eca77213.png";